var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.exam && (_vm.exam.instruction !== null && _vm.exam.instruction.length > 0))?_c('div',{staticClass:"mt-4"},[_c('mark-down',{attrs:{"message":_vm.exam.instruction}})],1):_c('div',{staticClass:"mt-4"},[_c('p',{staticClass:"no-instruction"},[_vm._v("ไม่มีรายละเอียดข้อสอบ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }